import { mount } from 'svelte';
import App from './App.svelte';
import './app.css';

// La app es siempre dark - no hay light mode. El theme store
// (theme.svelte.ts) se importa via los componentes y aplica el
// data-theme leido de localStorage. Aca solo nos aseguramos del
// dark hardcoded para el primer paint sin flash.
const html = document.documentElement;
html.classList.add('dark');
html.classList.remove('light');

const target = document.getElementById('app');
if (!target) {
  throw new Error('No se encontro el elemento #app en index.html');
}

const app = mount(App, { target });

export default app;
